module.exports = "img/ac3ba8.4aa77aa.png";